import { computed, effect, inject, Injectable } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';

import { FormControlNames } from '../../models/form-control-names.model';
import { GroupeÉtapesÀLaCarte } from '../../models/groupe-étapes-à-la-carte.model';
import { GroupeÉtapesÀLaCarteStore } from '../../store/groupe-étapes-à-la-carte/groupe-étapes-à-la-carte.store';

@Injectable({
  providedIn: 'root',
})
export class GroupeEtapesDetailContenuService {
  readonly #fb = inject(FormBuilder);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #groupeÉtapesStore = inject(GroupeÉtapesÀLaCarteStore);

  #groupeÉtapesSelectionné = computed(() => this.#groupeÉtapesStore.selectedEntity());
  #groupesEtapes = computed(() => this.#groupeÉtapesStore.entities());

  form: FormGroup = this.#fb.group({
    [FormControlNames.NOM]: [null, [this.#uniqueNameValidators()]],
    [FormControlNames.DUREE]: [null],
  });

  constructor() {
    effect(() => {
      const groupeÉtapes = this.#groupeÉtapesSelectionné();

      if (groupeÉtapes) {
        this.form.setValue(
          {
            [FormControlNames.NOM]: groupeÉtapes.nom ?? null,
            [FormControlNames.DUREE]: groupeÉtapes.duree ?? null,
          },
          { emitEvent: false },
        );
      }
    });
  }

  submit() {
    const groupeÉtapesSélectionné = this.#groupeÉtapesStore.selectedEntity();
    if (!groupeÉtapesSélectionné) return;

    this.#sidepanelService.loading.set(true);
    this.#groupeÉtapesStore.modifier({
      idGroupe: groupeÉtapesSélectionné.id,
      data: {
        nom: this.nom.value,
        duree: this.duree.value,
        idsEtapes: groupeÉtapesSélectionné.etapes.map((x) => x.id),
      },
      finalize: () => this.#sidepanelService.loading.set(false),
    });
  }

  get nom() {
    return this.form.get(FormControlNames.NOM) as FormControl<string>;
  }

  get duree() {
    return this.form.get(FormControlNames.DUREE) as FormControl<number>;
  }

  #uniqueNameValidators(): ValidatorFn {
    return (control: AbstractControl<string>): { [key: string]: any } | null => {
      if (!this.#groupesEtapes() || !control.value || !this.#groupeÉtapesSelectionné()) return null;

      const doublonsAvecGroupesExistants = this.#groupesEtapes().filter(
        (x) => control.value.trim() === x.nom.trim() && this.#groupeÉtapesSelectionné()?.id !== x.id,
      );
      return doublonsAvecGroupesExistants.length > 0 ? { notUnique: { value: true } } : null;
    };
  }
}
